import { FeatureToggleState as _FeatureToggleState } from '@interfaces/state';
import { Action, createReducer, on } from '@ngrx/store';

import * as featureActions from '../../actions';

export { FeatureToggle } from '@interfaces';

export interface FeatureToggleState extends _FeatureToggleState {}

export interface IFeatureToggle {
  featureId: string;
  enabled: boolean;
}

export const initialState: FeatureToggleState = {
  benes_by_relation: true,
  save_as_draft: false,
  control_person: true,
  gifting: true,
  gifting_scale_v2: true,
  internal_transfer_different_owners: false,
  internal_transfer_stp: false,
  cwp_ira_scale_trad: false,
  cwp_ira_scale_inh_roth: false,
  internal_transfer_joint: false,
  internal_transfer_trust: false,
  cwp_ira_scale_estate: false,
  cwp_ira_scale_trust: false,
  cwp_updated_mxm_enablement: false,
  cwp_ira_scale_trust_to_trust: false,
  cwp_internal_gifting_managed_accounts: false,
  intelledox_redirect_and_thresholds: false,
  joint_inheritance: false,
  inheritance_individual: false,
  inheritance_ira: false,
  cash_plus_internal_transfer: false,
  vcd_settlement_funds: false,
  doc_checklist_inheritance: false,
  cwp_multi_inheritance: false,
  cwp_it_estate_scale: false,
  cwp_ugma_utma_it: false,
  cwp_co0_minor: false,
  cwp_co0_inheritance: false,
  cwp_co0_internal_transfers: false,
  cwp_co0_upload: false,
  to_from_consolidation: false,
  cwp_co0_gifting: false,
  cwp_divorce: false,
};

const featureToggleReducer = createReducer(
  initialState,
  on(featureActions.EnableFeatureToggles, (state, { payload }) => ({
    ...state,
    ...payload.reduce((obj, feature) => ({ ...obj, [feature]: true }), {}),
  })),
  on(featureActions.UpdateFeatureToggleValue, (state, { payload }) => ({
    ...state,
    [payload.key]: payload.value,
  })),
);

export function reducer(state: FeatureToggleState | undefined, action: Action) {
  return featureToggleReducer(state, action);
}

export const getGiftingScaleToggleV2Value = (state: FeatureToggleState) => state.gifting_scale_v2;

export const getITJointToggle = (state: FeatureToggleState) => state.internal_transfer_joint;

export const getITTrustToggle = (state: FeatureToggleState) => state.internal_transfer_trust;

export const getUpdatedMXMToggle = (state: FeatureToggleState) => state.cwp_updated_mxm_enablement;

export const getIRAInheritedRothToggle = (state: FeatureToggleState) =>
  state.cwp_ira_scale_inh_roth;

export const getIRAInheritedTraditionalToggle = (state: FeatureToggleState) =>
  state.cwp_ira_scale_trad;

export const getIRATrustToggle = (state: FeatureToggleState) => state.cwp_ira_scale_trust;

export const getMultiInheritanceToggle = (state: FeatureToggleState) => state.cwp_multi_inheritance;

export const getToFromConsolidationToggle = (state: FeatureToggleState) =>
  state.to_from_consolidation;

export const getDivorceToggle = (state: FeatureToggleState) => state.cwp_divorce;
